import { DataWarehouseService } from "@identity/services";
import { inject, injectWithTransform, singleton } from "tsyringe";
import { Geo, Logger, LoggerTransformer } from "@identity/utils";
import { CMPTracker } from "../cmp-tracker";

@singleton()
export class OneTrustTracker extends CMPTracker {
  public cmpName = "1t";

  constructor(
    @injectWithTransform(Logger, LoggerTransformer, "OneTrustTracker")
    protected readonly logger: Logger,
    @inject(DataWarehouseService)
    protected readonly dataWarehouse: DataWarehouseService,
    @inject(Geo) protected readonly geo: Geo,
  ) {
    super(logger, dataWarehouse, geo);
  }

  sendGPCEvent() {
    if (!this.gpcRegistered) {
      this.gpcRegistered = true;
      this.logger.info("Queued sending GPC event");
      this.sendEvent("gpc", "impression");
    } else {
      this.logger.info("GPC event already sent");
    }
  }
}
